import React, { useEffect, useState } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useMutation } from "@apollo/client";
import Loader from "../../components/Loading";
import PageL1 from "../../components/Layout2Page";
import { useDispatch, useSelector } from "react-redux";
import MobileDesktop from "../../components/MobileSignUp";
import DesktopSignUp from "../../components/DesktopSignUp";
import { setUser } from "../../Redux/Actions/ltUserActions";
import { dashboardEventsTracker } from "../../utils/mixPanel";
import VerifyPhone from "../../components/Modals/VerifyPhone";
import { setCompanyDetails } from "../../Redux/Actions/companyActions";
import { setDotFunc, setLoader } from "../../Redux/Actions/loadingAction";
import NotificationDialog from "../../components/Modals/NotificationDialog";
import {
  GOOGLE_LOGIN,
  FACEBOOK_LOGIN,
  SIGNUP_MUTATION,
  GENERATE_OTP_MUTATION,
  SIGNUP_USER_WITH_MUTATION,
  UPDATE_USER_BY_EMAIL_MUTATION,
} from "../../pages/api/mutations";

const SignUp = () => {
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    const { dotNum, withOutDot, referralCode, token, result } = router.query;

    if (dotNum) dispatch(setDotFunc(dotNum));
    if (withOutDot) localStorage.setItem("withOutDot", true);
    if (referralCode) localStorage.setItem("referralCode", referralCode);
    if (token) {
      localStorage.setItem("result", true);
      localStorage.setItem("motiveToken", token);
    }

    if (token || referralCode || withOutDot || dotNum) {
      router.replace(process.env.NEXT_PUBLIC_USER_SIGNUP, undefined, {
        shallow: true,
      });
    }
  }, [router.query]);

  const { loading } = useSelector((state) => state.auth);
  const [googleLogin] = useMutation(GOOGLE_LOGIN, {
    errorPolicy: "all",
    fetchPolicy: "network-only",
  });
  const [facebookLogin] = useMutation(FACEBOOK_LOGIN, {
    errorPolicy: "all",
    fetchPolicy: "network-only",
  });
  const [updateUserPhone] = useMutation(UPDATE_USER_BY_EMAIL_MUTATION);
  const [formFields, setFormFields] = useState({
    firstName: { value: "", error: false, message: "" },
    lastName: { value: "", error: false, message: "" },
    email: { value: "", error: false, message: "" },
    phone: { value: "", error: false, message: "" },
    password: { value: "", error: false, message: "" },
    disabled: false,
    mainError: false,
    mainErrorMessage: "",
    errors: false,
  });
  const [countryCode, setCountry] = useState("+1");

  const [phone, setPhone] = useState({
    value: "",
    error: false,
    message: "",
  });
  const [open, setOpen] = useState(false);
  const [notificationDialog, setNotificationDialog] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    let utmData = {};

    const hostname = router.asPath;
    if (hostname) {
      if (hostname.split("?")?.length > 1) {
        const firstSplitSource = hostname.split("?");
        if (firstSplitSource?.length > 1 && firstSplitSource[1].includes("&")) {
          const secondSplitSource = firstSplitSource[1].split("&");
          if (
            secondSplitSource?.length > 0 &&
            secondSplitSource[0].includes("=")
          ) {
            const thirdSplitSource = secondSplitSource[0].split("=");
            if (thirdSplitSource?.length > 1) {
              utmData.utm_source = thirdSplitSource[1];
            }
          }
        }

        if (firstSplitSource?.length > 1 && firstSplitSource[1].includes("&")) {
          const secondSplitCampaign = firstSplitSource[1].split("&");
          if (
            secondSplitCampaign?.length > 1 &&
            secondSplitCampaign[1].includes("=")
          ) {
            const thirdSplitCampaign = secondSplitCampaign[1].split("=");
            if (thirdSplitCampaign?.length > 1) {
              utmData.utm_campaign = thirdSplitCampaign[1];
            }
          }
        }

        // utmData.utm_source = hostname.split("?")[1].split("&")[0].split("=")[1];
        // utmData.utm_campaign = hostname.split("?")[1].split("&")[1].split("=")[1];
        localStorage.setItem("utmData", JSON.stringify(utmData));
      }
    }

    // if (userData && userData.company) {
    //   if (userData.company) {
    //     Router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
    //   }
    // }
  }, []);

  //mutations
  useEffect(() => {
    dispatch(setLoader(false));
  }, []);

  const [signUp] = useMutation(SIGNUP_MUTATION, {
    fetchPolicy: "network-only",
    errorPolicy: "all",
  });
  const [singUpUserWithCompany] = useMutation(SIGNUP_USER_WITH_MUTATION, {
    fetchPolicy: "network-only",
    errorPolicy: "all",
  });
  const [generateOTP] = useMutation(GENERATE_OTP_MUTATION, {
    fetchPolicy: "network-only",
  });

  const onChangeDropdown = (e) => {
    setCountry(e.value);
  };

  const options = ["+92", "+1"];

  const onChange = ({ target: { name, value } }) => {
    for (let i in formFields) {
    }
    var someProperty = { ...formFields };
    someProperty.disabled = false;
    someProperty.errors = false;
    someProperty.mainError = false;
    someProperty.mainErrorMessage = "";
    someProperty[name].value = value;
    if (someProperty[name].error === true) {
      someProperty[name].error = false;
      someProperty[name].message = "";
    }
    setFormFields(someProperty);
  };

  const responseSocial = (response) => {
    if (Object.keys(response).includes("googleId")) {
      dispatch(setLoader(true));
      googleLogin({
        variables: {
          input: {
            accessToken: response.accessToken,
            org: process.env.NEXT_PUBLIC_ORGANIZATION,
          },
        },
      })
        .then((resp) => {
          if (resp.data.userLoginGoogle) {
            if (resp.data.userLoginGoogle.user) {
              dispatch(setUser(resp.data.userLoginGoogle.user));
            }
            dashboardEventsTracker(
              "UserLogin",
              resp.data.userLoginGoogle.user.email,
              {}
            );

            if (!resp.data.userLoginGoogle.user.phone) {
              let someProperty = { ...formFields };
              someProperty.email.value = resp.data.userLoginGoogle.user.email;
              setFormFields(someProperty);
              dispatch(setLoader(false));
              setOpen(true);
            } else if (
              !resp.data.userLoginGoogle.user.company &&
              resp.data.userLoginGoogle.user.phone
            ) {
              // procede to company dot
              localStorage.setItem("token", resp.data.userLoginGoogle.token);
              localStorage.setItem("withOutDot", true);
              Promise.all([
                dispatch(setUser(resp.data.userLoginGoogle.user)),
                dispatch(setLoader(false)),
              ]);
              router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
            }
            // // success flow if user is registered
            else if (
              resp.data.userLoginGoogle.user.company &&
              resp.data.userLoginGoogle.user.role === "User" &&
              resp.data.userLoginGoogle.user.accessAllowed === false
            ) {
              // show dialog
              dispatch(setLoader(false));
              setNotificationDialog(true);
            } else if (
              resp.data.userLoginGoogle.user.company &&
              resp.data.userLoginGoogle.user.role === "User" &&
              resp.data.userLoginGoogle.user.accessAllowed === true
            ) {
              localStorage.setItem(
                "mainToken",
                resp.data.userLoginGoogle.token
              );

              let data = Promise.all([
                dispatch(setLoader(false)),
                dispatch(setUser(resp.data.userLoginGoogle.user)),
                dispatch(
                  setCompanyDetails(resp.data.userLoginFacebook.user.company)
                ),
              ]);
              if (data) {
                router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
              }
            } else if (
              resp.data.userLoginGoogle.user.company &&
              resp.data.userLoginGoogle.user.role === "Admin" &&
              resp.data.userLoginGoogle.user.accessAllowed === false
            ) {
              dispatch(setLoader(false));
              setNotificationDialog(true);
            } else if (
              resp.data.userLoginGoogle.user.company &&
              resp.data.userLoginGoogle.user.role === "Admin" &&
              resp.data.userLoginGoogle.user.accessAllowed === true
            ) {
              localStorage.setItem(
                "mainToken",
                resp.data.userLoginGoogle.token
              );

              let data = Promise.all([
                dispatch(setLoader(false)),
                dispatch(setUser(resp.data.userLoginGoogle.user)),
                dispatch(
                  setCompanyDetails(resp.data.userLoginGoogle.user.company)
                ),
              ]);
              if (data) {
                router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
              }
            }
          } else {
            if (
              resp.errors[0].message.includes(
                "Please verify phone number first"
              )
            ) {
              setOpen(true);
              dispatch(setLoader(false));
            }
          }
        })
        .catch((e) => {
          console.log("Error", e.message);
          dispatch(setLoader(false));
        });
    } else {
      if (response.accessToken) {
        facebookLogin({
          variables: {
            input: {
              accessToken: response.accessToken,
              org: process.env.NEXT_PUBLIC_ORGANIZATION,
            },
          },
        })
          .then((resp) => {
            if (resp.data.userLoginFacebook) {
              if (resp.data.userLoginFacebook.user) {
                dispatch(setUser(resp.data.userLoginFacebook.user));
              }

              dashboardEventsTracker(
                "UserLogin",
                resp.data.userLoginFacebook.user.email,
                {}
              );

              if (!resp.data.userLoginFacebook.user.phone) {
                // procede to phone number
                // set otp
                dispatch(setLoader(false));
                setOpen(true);
              } else if (
                !resp.data.userLoginFacebook.user.company &&
                resp.data.userLoginFacebook.user.phone
              ) {
                // procede to company dot
                localStorage.setItem(
                  "token",
                  resp.data.userLoginFacebook.token
                );
                localStorage.setItem("withOutDot", true);
                Promise.all([
                  dispatch(setUser(resp.data.userLoginFacebook.user)),
                  dispatch(setLoader(false)),
                ]);
                router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
              }
              // // success flow if user is registered
              else if (
                resp.data.userLoginFacebook.user.company &&
                resp.data.userLoginFacebook.user.role === "User" &&
                resp.data.userLoginFacebook.user.accessAllowed === false
              ) {
                // show dialog
                dispatch(setLoader(false)), setNotificationDialog(true);
              } else if (
                resp.data.userLoginFacebook.user.company &&
                resp.data.userLoginFacebook.user.role === "User" &&
                resp.data.userLoginFacebook.user.accessAllowed === true
              ) {
                localStorage.setItem(
                  "mainToken",
                  resp.data.userLoginFacebook.token
                );
                // saveUserDataInLocalStorage(
                //   resp.data.userLoginGoogle.user,
                //   resp.data.userLoginGoogle.token,
                //   resp.data.userLoginGoogle.user.company,
                //   "company"
                // );
                Promise.all([
                  dispatch(setLoader(false)),
                  dispatch(setUser(resp.data.userLoginFacebook.user)),
                ]);
                // dispatch(saveUserDetailsAction(resp.data.userLoginGoogle.user));
                // setLoader(false);
                // dashboardEventsTracker("UserLogin")
                // smartLookIdentifying()
                router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
              } else if (
                resp.data.userLoginFacebook.user.company &&
                resp.data.userLoginFacebook.user.role === "Admin" &&
                resp.data.userLoginFacebook.user.accessAllowed === false
              ) {
                dispatch(setLoader(false));
                setNotificationDialog(true);
              } else if (
                resp.data.userLoginFacebook.user.company &&
                resp.data.userLoginFacebook.user.role === "Admin" &&
                resp.data.userLoginFacebook.user.accessAllowed === true
              ) {
                // saveUserDataInLocalStorage(
                //   resp.data.userLoginGoogle.user,
                //   resp.data.userLoginGoogle.token,
                //   resp.data.userLoginGoogle.user.company,
                //   "company"
                // );
                // dispatch(saveUserDetailsAction(resp.data.userLoginGoogle.user));
                // setLoader(false);
                // dashboardEventsTracker("UserLogin")
                // smartLookIdentifying()
                localStorage.setItem(
                  "mainToken",
                  resp.data.userLoginFacebook.token
                );
                // saveUserDataInLocalStorage(
                //   resp.data.userLoginGoogle.user,
                //   resp.data.userLoginGoogle.token,
                //   resp.data.userLoginGoogle.user.company,
                //   "company"
                // );
                Promise.all([
                  dispatch(setLoader(false)),
                  dispatch(setUser(resp.data.userLoginFacebook.user)),
                  dispatch(
                    setCompanyDetails(resp.data.userLoginFacebook.user.company)
                  ),
                ]);
                // dispatch(saveUserDetailsAction(resp.data.userLoginGoogle.user));
                // setLoader(false);
                // dashboardEventsTracker("UserLogin")
                // smartLookIdentifying()
                router.push(process.env.NEXT_PUBLIC_USER_DASHBOARD);
              }
            } else {
            }
          })
          .catch((e) => {
            dispatch(setLoader(false));
          });
      }
    }
  };

  const validators = async () => {
    var someProperty = { ...formFields };
    if (someProperty.email.value === "") {
      someProperty.email.error = true;
      someProperty.email.message = "Email is required.";
      someProperty.errors = true;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        someProperty.email.value.trim()
      )
    ) {
      someProperty.email.error = true;
      someProperty.email.message =
        "Invalid email address. E.g. example@email.com.";
      someProperty.errors = true;
    }

    if (someProperty.password.value === "") {
      someProperty.password.error = true;
      someProperty.password.message = "Password is required.";
      someProperty.errors = true;
    } else if (someProperty.password?.length < 6) {
      someProperty.email.error = true;
      someProperty.email.message =
        "Invalid Password. Password should be at least 6 characters.";
      someProperty.errors = true;
    }
    if (someProperty.phone.value === "") {
      someProperty.phone.error = true;
      someProperty.phone.message = "Phone is required.";
      someProperty.errors = true;
    } else if (
      !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
        someProperty.phone.value
      ) ||
      someProperty.phone.value.replace(/[^0-9]/g, "")?.length > 10
    ) {
      someProperty.phone.error = true;
      someProperty.phone.message =
        "Phone number is not valid. (Examples: (123) 456-7890 / 123-456-7890 / 1234567890.";
      someProperty.errors = true;
    }
    if (someProperty.firstName.value === "") {
      someProperty.firstName.error = true;
      someProperty.firstName.message = "First Name is required.";
      someProperty.errors = true;
    }
    if (someProperty.lastName.value === "") {
      someProperty.lastName.error = true;
      someProperty.lastName.message = "Last Name is required.";
      someProperty.errors = true;
    }

    if (someProperty.errors) {
      someProperty.disabled = true;
    }
    setFormFields(someProperty);
    return someProperty.errors ? true : false;
  };

  const MobileFirstValidators = async () => {
    var someProperty = { ...formFields };
    if (someProperty.email.value === "") {
      someProperty.email.error = true;
      someProperty.email.message = "Email is required.";
      someProperty.errors = true;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        someProperty.email.value.trim()
      )
    ) {
      someProperty.email.error = true;
      someProperty.email.message =
        "Invalid email address. E.g. example@email.com.";
      someProperty.errors = true;
    }

    if (someProperty.firstName.value === "") {
      someProperty.firstName.error = true;
      someProperty.firstName.message = "First Name is required.";
      someProperty.errors = true;
    }
    if (someProperty.lastName.value === "") {
      someProperty.lastName.error = true;
      someProperty.lastName.message = "Last Name is required.";
      someProperty.errors = true;
    }

    if (someProperty.errors) {
      someProperty.disabled = true;
    }
    setFormFields(someProperty);
    return someProperty.errors ? true : false;
  };

  const passValidators = async () => {
    var someProperty = { ...formFields };
    if (someProperty.password.value === "") {
      someProperty.password.error = true;
      someProperty.password.message = "Password is required.";
      someProperty.errors = true;
    } else if (someProperty.password?.length < 6) {
      someProperty.password.error = true;
      someProperty.password.message =
        "Invalid Password. Password should be at least 6 characters.";
      someProperty.errors = true;
    }
    if (someProperty.errors) {
      someProperty.disabled = true;
    }

    setFormFields(someProperty);
    return someProperty.errors ? true : false;
  };

  const phoneValidators = async () => {
    var someProperty = { ...formFields };
    if (someProperty.phone.value === "") {
      someProperty.phone.error = true;
      someProperty.phone.message = "Phone is required.";
      someProperty.errors = true;
    } else if (
      !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
        someProperty.phone.value
      ) ||
      someProperty.phone.value.replace(/[^0-9]/g, "")?.length > 10
    ) {
      someProperty.phone.error = true;
      someProperty.phone.message =
        "Phone number is not valid. (Examples: (123) 456-7890 / 123-456-7890 / 1234567890.";
      someProperty.errors = true;
    }
    if (someProperty.errors) {
      someProperty.disabled = true;
    }

    setFormFields(someProperty);
    return someProperty.errors ? true : false;
  };

  const buttonClickedSignUp = async () => {
    let test = await validators();
    if (!test) {
      if (router.query && router.query.companyId) {
        dispatch(setLoader(true));
        try {
          let res = await singUpUserWithCompany({
            variables: {
              email: formFields.email.value,
              name: `${formFields.firstName.value} ${formFields.lastName.value}`,
              password: formFields.password.value,
              phone: `${countryCode}${formFields.phone.value}`,
              companyId: router.query.companyId,
            },
          });
          dashboardEventsTracker("UserSignup", formFields.email, {});

          if (res.data.singUpUserWithCompany) {
            generateOTP({
              variables: {
                to: `${countryCode}${formFields.phone.value}`,
                channel: "sms",
              },
            });
            dispatch(setLoader(false));
            setTimeout(() => {
              router.push(process.env.NEXT_PUBLIC_CODE_VERIFICATION);
              dispatch(
                setUser({
                  email: formFields.email.value,
                  phone: `${countryCode}${formFields.phone.value}`,
                  password: formFields.password.value,
                })
              );
            }, 200);
          } else {
            dispatch(setLoader(false));
            if (res.errors[0].message === "email already exits!") {
              var someProperty = { ...formFields };
              someProperty.mainError = true;
              someProperty.mainErrorMessage =
                "The account with the given credentials already exists. Please log in.";
              someProperty.disabled = true;
              setFormFields(someProperty);
            } else {
              var someProperty = { ...formFields };
              someProperty.mainError = true;
              someProperty.mainErrorMessage = `${res.errors[0].message}`;
              someProperty.disabled = true;
              setFormFields(someProperty);
            }
          }
        } catch (error) {
          dispatch(setLoader(false));
          if (error.graphQLErrors) {
            let someProperty = { ...formFields };
            const err = error.graphQLErrors[0].message;
            someProperty.mainError = true;
            someProperty.mainErrorMessage = `${error.graphQLErrors[0].message}`;
            someProperty.disabled = true;
            setFormFields(someProperty);
          }
        }
      } else {
        dispatch(setLoader(true));
        try {
          let res = await signUp({
            variables: {
              email: formFields.email.value,
              password: formFields.password.value,
              name: `${formFields.firstName.value} ${formFields.lastName.value}`,
              phone: `${countryCode}${formFields.phone.value}`,
              role: "Admin",
              accessAllowed: true,
              org: process.env.NEXT_PUBLIC_ORGANIZATION,
            },
          });

          dashboardEventsTracker("UserSignup", formFields.email, {});

          if (res.data.signUp) {
            generateOTP({
              variables: {
                to: `${countryCode}${formFields.phone.value}`,
                channel: "sms",
              },
            });
            dispatch(setLoader(false));
            setTimeout(() => {
              router.push(process.env.NEXT_PUBLIC_CODE_VERIFICATION);
              dispatch(
                setUser({
                  email: formFields.email.value,
                  phone: `${countryCode}${formFields.phone.value}`,
                  password: formFields.password.value,
                })
              );
            }, 200);
          } else {
            dispatch(setLoader(false));
            if (res.errors[0].message === "email already exits!") {
              var someProperty = { ...formFields };
              someProperty.mainError = true;
              someProperty.mainErrorMessage =
                "The account with the given credentials already exists. Please log in.";
              someProperty.disabled = true;
              setFormFields(someProperty);
            } else {
              var someProperty = { ...formFields };
              someProperty.mainError = true;
              someProperty.mainErrorMessage = `${res.errors[0].message}`;
              someProperty.disabled = true;
              setFormFields(someProperty);
            }
          }
        } catch (error) {
          dispatch(setLoader(false));
          if (error.graphQLErrors) {
            let someProperty = { ...formFields };
            const err = error.graphQLErrors[0].message;
            someProperty.mainError = true;
            someProperty.mainErrorMessage = `${error.graphQLErrors[0].message}`;
            someProperty.disabled = true;
            setFormFields(someProperty);
          }
        }
      }
    }
  };

  const onChangePhone = (e) => {
    setPhone({
      ...phone,
      value: e.target.value,
      error: false,
      message: "",
    });
  };

  const buttonClickedUpdatePhone = async () => {
    if (phone.value?.length < 6) {
      return setPhone({
        ...phone,
        error: true,
        message: "Phone should be 10 digits.",
      });
    } else {
      dispatch(setLoader(true));
      try {
        let res = await updateUserPhone({
          variables: {
            email: formFields.email.value,
            phone: `${countryCode}${phone.value}`,
          },
        });
        if (res && res.data.updateUserByEmail) {
          const otpRes = await generateOTP({
            variables: {
              to: `${res.data.updateUserByEmail.phone}`,
              channel: "sms",
            },
          });
          dispatch(setLoader(false));
          if (otpRes) {
            dispatch(
              setUser({
                email: formFields.email.value,
                phone: `${countryCode}${phone.value}`,
              })
            );
            // closeUpdateModalFunc();
            setOpen(false);
            router.push(process.env.NEXT_PUBLIC_CODE_VERIFICATION);
            setPhone({ ...phone, value: "" });
          } else {
            return setPhone({
              ...phone,
              error: true,
              message: "invalid phone number",
            });
          }
        }
      } catch (error) {
        dispatch(setLoader(false));
        if (error.graphQLErrors) {
          if (error.graphQLErrors[0].message.includes("Unique constraint")) {
            return setPhone({
              ...phone,
              error: true,
              message: `phone already exists`,
            });
          }
          return setPhone({
            ...phone,
            error: true,
            message: `${error.graphQLErrors[0].message}`,
          });
        }
      }
    }
  };

  return (
    <PageL1
      title={
        process.env.NEXT_PUBLIC_THEME === "LT"
          ? "Trucking Insurance Provider | LuckyTruck"
          : "Trucking Insurance Provider | Flexport"
      }
    >
      <Head>
        <meta
          name="title"
          content="LuckyTruck | SignUp | We're here to help! Buy commercial trucking insurance and manage it through one seamless platform. Get started now"
        />
        <meta
          name="keywords"
          content="trucking Insurance, truck insurance providers"
        />
        <meta
          name="description"
          content="Looking for a trucking insurance that won't break the bank? LuckyTruck has you covered! We offer affordable rates and comprehensive coverage, so you can rest assured that your truck is protected. Give us a call today to get started!"
        />
      </Head>

      {/* {isBig || isDesk || isTab ? <DesktopSignUp /> : <MobileDesktop />} */}
      <DesktopSignUp
        formFields={formFields}
        countryCode={countryCode}
        responseSocial={responseSocial}
        options={options}
        onChangeDropdown={onChangeDropdown}
        onChange={onChange}
        buttonClicked={buttonClickedSignUp}
      />
      <MobileDesktop
        formFields={formFields}
        countryCode={countryCode}
        responseSocial={responseSocial}
        options={options}
        validators={MobileFirstValidators}
        passValidators={passValidators}
        phoneValidators={phoneValidators}
        onChangeDropdown={onChangeDropdown}
        buttonClicked={buttonClickedSignUp}
        onChange={onChange}
      />

      {open ? (
        <VerifyPhone
          open={open}
          onClose={() => setOpen(false)}
          phone={phone}
          options={options}
          countryCode={countryCode}
          onChangeDropdown={onChangeDropdown}
          onChangePhone={onChangePhone}
          buttonClickedUpdatePhone={buttonClickedUpdatePhone}
        />
      ) : null}
      {notificationDialog ? (
        <NotificationDialog
          open={notificationDialog}
          onClose={() => setNotificationDialog(false)}
          des="Since your company and Admin are already registered with LuckyTruck, we have requested access on your behalf from the Admin. Once your request is approved by the admin you will be able to access the System."
          navigation={process.env.NEXT_PUBLIC_USER_LOGIN}
        />
      ) : null}
      {loading && <Loader />}
    </PageL1>
  );
};

export default SignUp;
